import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import moment from "moment";
import ReactPlayer from "react-player";
import Nodata from "../../assets/Icon/Nodata.png";
import { serverInfo } from "../../App";
import { useContext } from "react";

const AllModuleData = (props) => {
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  const { data } = props;
  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };
  return (
    <>
      {currentItems.length !== 0 ? (
        <>
          <div className="py-3">
            <div className="row ">
              {currentItems.map((event_data) => {
                return (
                  <>
                    <div className="col-sm-12 col-md-6 col-lg-3 mb-3">
                      <div className="completedMeetupBlack card-bg">
                        {event_data.banner ? (
                          <>
                            <Link
                              to={`${props.urlLink}/${event_data.id}`}
                              className="Link"
                            >
                              <img
                                src={imageCdnUrl + event_data.banner}
                                className="img-fluid image-hover-link"
                                alt=""
                                style={{ height: "200px", width: "100%" }}
                              />
                            </Link>
                          </>
                        ) : (
                          <>
                            <ReactPlayer
                              url={videoCdnUrl + event_data.video}
                              controls={true}
                              volume={1}
                              width="100%"
                              height="200px"
                              style={{ margin: "0 auto" }}
                            />
                          </>
                        )}
                        <Link
                          to={`${props.urlLink}/${event_data.id}`}
                          className="Link"
                        >
                          <div className="p-3">
                            <div className="under-line-warning my-2"></div>
                            <div className="d-flex justify-content-between">
                              <h6 className="text-white text-ellipsis Title_Link">
                                {event_data.title}
                                {event_data.group_name}
                              </h6>
                            </div>
                            <p className="text-secondary head-line p-2 mt-2">
                              {props.fan ? (
                                <>
                                  <span className="text-light">
                                    {moment(event_data.event_date).format("LL")}
                                  </span>
                                  -
                                  <span className="text-light">
                                    {moment(event_data.end_date).format("LL")}
                                  </span>
                                </>
                              ) : props?.qna ? (
                                <>
                                  <span className="text-light">
                                    {moment(event_data.star_availability_start_date).format("LL")}
                                  </span>
                                  {' '}to{' '} 
                                  <span className="text-light">
                                    {moment(event_data.star_availability_end_date).format("LL")}
                                  </span>
                                </>
                              ) : (
                                <>
                                  <h6 className="text-warning fw-bold">
                                    {moment(event_data.event_date).format("LL")}
                                  </h6>
                                  <span className="text-light">
                                    {moment(
                                      event_data.start_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm A")}
                                  </span>
                                  -
                                  <span className="text-light">
                                    {moment(
                                      event_data.end_time,
                                      "HH:mm:ss"
                                    ).format("hh:mm A")}
                                  </span>
                                </>
                              )}
                            </p>
                          </div>
                        </Link>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div id="react-paginate">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </>
      ) : (
        <>
          <div className="row justify-content-center align-items-center">
            <div className="d-flex col-md-12 justify-content-center align-items-center my-5">
              <img src={Nodata} alt="" className=" Nodata" />
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default AllModuleData;
